var map = {
	"./modulos/agenda/agenda.module": [
		"./src/app/modulos/agenda/agenda.module.ts",
		"modulos-agenda-agenda-module"
	],
	"./modulos/contacto/contacto.module": [
		"./src/app/modulos/contacto/contacto.module.ts",
		"modulos-contacto-contacto-module"
	],
	"./modulos/difusion/difusion.module": [
		"./src/app/modulos/difusion/difusion.module.ts",
		"modulos-difusion-difusion-module~modulos-gaceta-parlamentaria-gaceta-parlamentaria-module~modulos-in~313ef0a1",
		"modulos-difusion-difusion-module"
	],
	"./modulos/diputados/diputados.module": [
		"./src/app/modulos/diputados/diputados.module.ts",
		"modulos-diputados-diputados-module"
	],
	"./modulos/gaceta-parlamentaria/gaceta-parlamentaria.module": [
		"./src/app/modulos/gaceta-parlamentaria/gaceta-parlamentaria.module.ts",
		"modulos-difusion-difusion-module~modulos-gaceta-parlamentaria-gaceta-parlamentaria-module~modulos-in~313ef0a1",
		"modulos-gaceta-parlamentaria-gaceta-parlamentaria-module"
	],
	"./modulos/infomaya/infomaya.module": [
		"./src/app/modulos/infomaya/infomaya.module.ts",
		"modulos-difusion-difusion-module~modulos-gaceta-parlamentaria-gaceta-parlamentaria-module~modulos-in~313ef0a1",
		"modulos-infomaya-infomaya-module"
	],
	"./modulos/inicio/inicio.module": [
		"./src/app/modulos/inicio/inicio.module.ts",
		"modulos-inicio-inicio-module"
	],
	"./modulos/institucional/institucional.module": [
		"./src/app/modulos/institucional/institucional.module.ts",
		"modulos-institucional-institucional-module"
	],
	"./modulos/legislacion/legislacion.module": [
		"./src/app/modulos/legislacion/legislacion.module.ts",
		"modulos-difusion-difusion-module~modulos-gaceta-parlamentaria-gaceta-parlamentaria-module~modulos-in~313ef0a1",
		"modulos-legislacion-legislacion-module"
	],
	"./modulos/orden-dia/orden-dia.module": [
		"./src/app/modulos/orden-dia/orden-dia.module.ts",
		"modulos-orden-dia-orden-dia-module"
	],
	"./modulos/plantillas/plantillas.module": [
		"./src/app/modulos/plantillas/plantillas.module.ts",
		"modulos-plantillas-plantillas-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;